module.exports = __webpack_public_path__ + "img/6_148.f82a4dcf.png";